<section class="page-center-card">
  <div class="card mx-2">
    <div class="card-body">
      <div class="px-sm-3">

        <div class="row">
          <div class="col-12 col-lg-12">
            <label for="id-consulta">Digite o ID da consulta</label>
            <input [formControl]="idControl" id="id-consulta" type="text" class="form-control">
            <app-msg-erro [control]="idControl"></app-msg-erro>
          </div>

          <div class="col-12 col-lg-12">
            <div class="py-4 d-flex align-items-end">
              <app-input-radio size="lg" [(model)]="tipoPesquisaVeiculo" value="placa" label="Placa" class="mr-4">
              </app-input-radio>
              <app-input-radio size="lg" [(model)]="tipoPesquisaVeiculo" value="chassi" label="Chassi" class="mr-4">
              </app-input-radio>
              <app-input-radio size="lg" [(model)]="tipoPesquisaVeiculo" value="motor" label="Motor" class="mr-4">
              </app-input-radio>
              <app-input-radio size="lg" [(model)]="tipoPesquisaVeiculo" value="cpf_cnpj" label="CPF/CNPJ" class="mr-4">
              </app-input-radio>
            </div>
            <div class="">
              <label for="pesquisaVeiculo">
                Digite
                {{
                  tipoPesquisaVeiculo=='placa' ? ' a Placa do veículo' : 
                  tipoPesquisaVeiculo=='chassi' ? ' o Chassi do veículo' : 
                  tipoPesquisaVeiculo=='cpf_cnpj' ? ' o CPF da Pessoa ou CNPJ da Empresa' : ' o Motor do veículo'
                }}
              </label>
              <input *ngIf="tipoPesquisaVeiculo=='placa'" [textMask]="masks.placa" type="text"
                [formControl]="placaControl" class="form-control input-validate text-uppercase">
              <input *ngIf="tipoPesquisaVeiculo=='chassi'" type="text" [formControl]="chassiControl"
                class="form-control input-validate text-uppercase">
              <input *ngIf="tipoPesquisaVeiculo=='motor'" type="text" [formControl]="motorControl"
                class="form-control input-validate text-uppercase">
              <input *ngIf="tipoPesquisaVeiculo=='cpf_cnpj'" [textMask]="masks.documento" type="text"
                [formControl]="cpf_cnpjControl" class="form-control input-validate text-uppercase">
              <app-msg-erro [control]="
                tipoPesquisaVeiculo=='placa' ? placaControl
                : tipoPesquisaVeiculo=='chassi' ? chassiControl
                : tipoPesquisaVeiculo=='cpf_cnpj' ? cpf_cnpjControl
                : motorControl">
              </app-msg-erro>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="card-footer d-flex justify-content-end bg-white">
      <button [disabled]="idControl.invalid || (
          tipoPesquisaVeiculo=='placa' ? placaControl
          : tipoPesquisaVeiculo=='chassi' ? chassiControl
          : tipoPesquisaVeiculo=='cpf_cnpj' ? cpf_cnpjControl
          : motorControl
        ).invalid" (click)="formSubmit()" class="btn btn-lg btn-primary btn-icon px-5">
        <i class="mdi mdi-magnify"></i>
        <span>Resgatar consulta</span>
      </button>
    </div>
  </div>
</section>